import Inputmask from "inputmask";
import moment from "moment";

const im = new Inputmask("99/99/9999", {
    placeholder: "MM/DD/YYYY",
    showMaskOnHover: false,
    showMaskOnFocus: true,
    clearIncomplete: true,
    rightAlign: false,
    positionCaretOnClick: "lvp",   // "last valid position" – lets you edit inside the string
    insertMode: true,              // keeps insert behavior natural
    insertModeVisual: true,
});

export const  formatDOB = (dob) => dob ? moment(dob).format("MM/DD/YYYY") : "";

export function validateDate(date, isDob, dateErr = []){

    if(date === undefined){
        return;
    }

    if(!date.includes('/')){
        return;
    }

    let invalid = false;

    if(date && (!moment(date, "MM/DD/YYYY", true).isValid() || 
        moment(date).isAfter(moment()))){
        if(isDob){
            dateErr.push(<div>Please enter a valid DOB in MM/DD/YYYY format.</div>);
        } else {
            dateErr.push(<div>Please enter a valid Date in MM/DD/YYYY format.</div>);
        }
        invalid = true;
    }
    console.log("date: ", date);
        

    if(date !== undefined){
        const [ month, day, year] = date.split("/");
        console.log(day + " : " + month)

        if(month === ""){
            return;
        }

        if((month > 12) || (month < 1)){
            dateErr.push(<div>The Field MM must be between 01 and 12</div>);
            invalid = true; 
        }

        if((day > 31) || (day < 1)){
            dateErr.push(<div>The field DD must be between 01 and 31</div>);
            invalid = true;
        }
    }
    
    if(invalid){
        return dateErr;
    }
}
/*    



        let invalid = false;
        let dateErr = []
        if(e.target.DriverDOB?.value && (!moment(e.target.DriverDOB.value, "MM/DD/YYYY", true).isValid() || 
            moment(e.target.DriverDOB.value).isAfter(moment()))){
            dateErr.push(<div>Please enter a valid DOB in MM/DD/YYYY format.</div>);
            setInvalidDOB(true);
            invalid = true;
        }
        const akaDOBs = document.querySelectorAll('input[name="DriverAkaDOB"]');
        console.log("AKA DOBs: ", akaDOBs);
        akaDOBs?.forEach((dobInput, indx) => {
            if(dobInput?.value && (!moment(dobInput.value, "MM/DD/YYYY", true).isValid() || moment(dobInput.value).isAfter(moment()))){
                dateErr.push(<div>Please enter a valid AKA {indx + 1} DOB in MM/DD/YYYY format.</div>);
                setInvalidDOB(true);
                invalid = true;
            }
        });

        if(e?.target?.DriverDOB?.value !== undefined){
            const month = e?.target?.DriverDOB?.value.slice(0,2);
            const day = e?.target?.DriverDOB?.value.slice(3,5);

            if(month > 12){
            dateErr.push(<div>The Field MM must be between 1 and 12</div>);
            invalid = true; 
            }

            if(day > 31){
                dateErr.push(<div>The field DD must be between 1 and 31</div>);
                invalid = true;
            }
        }

        const hasWarnings = Object.values(warnings).some(value => {
            if (Array.isArray(value)) {
            return value.some(inner => inner && inner.trim() !== "");
            }
            return value && value.trim() !== "";

        });

        if (hasWarnings) {
            setShowError(true);
            invalid = true;
        }

        if(invalid){
            setAkaDateErr(dateErr)
            return;
        }
    */